import { BRICK_COLOR_CATALOG } from '../../entities/events/oneOff';
import styles from './BrickColor.module.scss';

export const BrickColor = ({ value }: { value?: string | null }) => {
  const color = value ? BRICK_COLOR_CATALOG[value] : undefined;
  if (!color) return <span>{value || '-'}</span>;

  return (
    <span className={styles.colorCell}>
      <span aria-hidden='true' className={styles.colorSwatch} style={{ backgroundColor: color.background }} />
      {color.label}
    </span>
  );
};
